import type { Operator, Tariff } from "@/types/Operator";
import type { Pagination } from "@/types/Pagination";
import Api from "./Api";

export class OperatorApi {
  static async getAll(limit: number, offset: number) {
    const { data } = await Api.get<Pagination<Operator>>("/operator/", {
      params: { limit, offset },
    });
    return data;
  }

  static async getAllTariffs(limit: number, offset: number, operator_id?: number) {
    const { data } = await Api.get<Pagination<Tariff>>("/tariff/", {
      params: { limit, offset, operator_id },
    });
    return data;
  }
}
